// Stratus v2's icon set (ADR 0010): 24 × 24 stroke-only drawings, fill none, drawn in
// currentColor. The stroke width comes from where the icon sits (1.7 in the rail, 2 in
// buttons). The first ten are the Sierra Operations Panel's nav icons, as drawn there;
// the rest are drawn in the same style for ITC Web.

type Shape =
  | readonly ['path', { readonly d: string }]
  | readonly ['circle', { readonly cx: number; readonly cy: number; readonly r: number }]
  | readonly ['ellipse', { readonly cx: number; readonly cy: number; readonly rx: number; readonly ry: number }]
  | readonly ['rect', { readonly x: number; readonly y: number; readonly width: number; readonly height: number; readonly rx?: number }];

export const ICONS = {
  // From Sierra.
  bridge: [['path', { d: 'M3 12h4l3-7 4 14 3-7h4' }]],
  ops: [
    ['circle', { cx: 8, cy: 8, r: 3 }],
    ['circle', { cx: 17, cy: 9, r: 2.5 }],
    ['path', { d: 'M2.5 20c.6-3.6 2.8-5.5 5.5-5.5s4.9 1.9 5.5 5.5M14 15.2c.9-.5 1.9-.7 3-.7 2.3 0 4 1.6 4.5 5' }],
  ],
  people: [
    ['rect', { x: 4, y: 3, width: 16, height: 18, rx: 2 }],
    ['circle', { cx: 12, cy: 10, r: 3 }],
    ['path', { d: 'M7.5 18c.8-2.3 2.5-3.5 4.5-3.5s3.7 1.2 4.5 3.5' }],
  ],
  supply: [['path', { d: 'M3 7l9-4 9 4v10l-9 4-9-4z' }], ['path', { d: 'M3 7l9 4 9-4M12 11v10' }]],
  ships: [['path', { d: 'M2 15l4-1 3-6h6l3 6 4 1-2 4H4z' }], ['path', { d: 'M9 8l1-4h4l1 4M12 11v3' }]],
  requests: [['path', { d: 'M4 13l3-8h10l3 8v6H4z' }], ['path', { d: 'M4 13h5l1 2h4l1-2h5' }]],
  donations: [['path', { d: 'M12 20s-7-4.3-9.2-8.6A5 5 0 0 1 12 6.3a5 5 0 0 1 9.2 5.1C19 15.7 12 20 12 20z' }]],
  bank: [['ellipse', { cx: 12, cy: 6, rx: 7, ry: 3 }], ['path', { d: 'M5 6v6c0 1.7 3.1 3 7 3s7-1.3 7-3V6M5 12v6c0 1.7 3.1 3 7 3s7-1.3 7-3v-6' }]],
  library: [['path', { d: 'M4 4h5v16H4zM10 4h5v16h-5z' }], ['path', { d: 'M16 5l4 1-3 14-4-1' }]],
  refinery: [['circle', { cx: 12, cy: 13, r: 8 }], ['path', { d: 'M12 9v4l3 2M9 2h6' }]],
  search: [['circle', { cx: 11, cy: 11, r: 6.5 }], ['path', { d: 'M16 16l4.5 4.5' }]],
  // ITC Web's, in the same style.
  home: [['path', { d: 'M3 11l9-7 9 7' }], ['path', { d: 'M5.5 9.5V20h13V9.5M10 20v-5.5h4V20' }]],
  blueprints: [['path', { d: 'M4 4h16v16H4z' }], ['path', { d: 'M4 10h16M10 4v16M14 14h3M14 17h3' }]],
  shipyards: [['path', { d: 'M3 18c3 2 6 2 9 0s6-2 9 0' }], ['path', { d: 'M6 15l1-6h10l1 6M12 9V4h4' }]],
  fleet: [
    ['rect', { x: 8, y: 3, width: 8, height: 5, rx: 1.5 }],
    ['rect', { x: 2.5, y: 16, width: 8, height: 5, rx: 1.5 }],
    ['rect', { x: 13.5, y: 16, width: 8, height: 5, rx: 1.5 }],
    ['path', { d: 'M12 8v4M6.5 16v-4h11v4' }],
  ],
  members: [['circle', { cx: 8, cy: 7.5, r: 3 }], ['path', { d: 'M2.5 19c.6-3 2.7-4.5 5.5-4.5s4.9 1.5 5.5 4.5M16 8h5.5M16 12h5.5M16.5 16h5' }]],
  timers: [['path', { d: 'M6 3h12M6 21h12' }], ['path', { d: 'M7.5 3c0 4.5 9 4.5 9 9s-9 4.5-9 9M16.5 3c0 4.5-9 4.5-9 9s9 4.5 9 9' }]],
  user: [['circle', { cx: 12, cy: 8, r: 4 }], ['path', { d: 'M4.5 20.5c.9-4 3.8-6 7.5-6s6.6 2 7.5 6' }]],
  admin: [['path', { d: 'M12 3l8 3v6c0 4.5-3.4 7.8-8 9-4.6-1.2-8-4.5-8-9V6z' }], ['path', { d: 'M9 12l2 2 4-4' }]],
  inbox: [['path', { d: 'M6 16v-5a6 6 0 0 1 12 0v5l2 2H4z' }], ['path', { d: 'M10 21h4' }]],
  settings: [
    ['path', { d: 'M4 6h10M18 6h2M4 12h4M12 12h8M4 18h12' }],
    ['circle', { cx: 16, cy: 6, r: 2 }],
    ['circle', { cx: 10, cy: 12, r: 2 }],
    ['circle', { cx: 18, cy: 18, r: 2 }],
  ],
  apps: [
    ['rect', { x: 4, y: 4, width: 6.5, height: 6.5, rx: 1.5 }],
    ['rect', { x: 13.5, y: 4, width: 6.5, height: 6.5, rx: 1.5 }],
    ['rect', { x: 4, y: 13.5, width: 6.5, height: 6.5, rx: 1.5 }],
    ['rect', { x: 13.5, y: 13.5, width: 6.5, height: 6.5, rx: 1.5 }],
  ],
  plus: [['path', { d: 'M12 5v14M5 12h14' }]],
  close: [['path', { d: 'M6 6l12 12M18 6L6 18' }]],
  chevron: [['path', { d: 'M9 6l6 6-6 6' }]],
} as const satisfies Record<string, readonly Shape[]>;

/** The name of an icon in Stratus v2's set. */
export type IconName = keyof typeof ICONS;

export const ICON_NAMES = Object.keys(ICONS) as IconName[];
